var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.$style.link,on:{"click":_vm.share}},[_vm._v(_vm._s(_vm.type === 'facebook' ? 'Facebook' : 'Twitter'))])
}
var staticRenderFns = []

export { render, staticRenderFns }